import React from 'react';
import { compose } from 'redux';
import { Navigate } from 'react-router-dom';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import { usePermission } from '@contexts/Auth/UsePermission';
import List from './components/List';
import Page403 from '@page/Common/403/403';

const ConsumptionMonitoring = () => {
  const { consumptionMonitoring } = usePermission();

  // Check permission - redirect to 403 if no view permission
  if (!consumptionMonitoring?.view) {
    return (
      <ContainerBody>
        <Page403 />
      </ContainerBody>
    );
  }

  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb homePath={'/dashboard'} routeSegments={[{ name: 'Theo dõi tiêu thụ' }]} />
      </div>
      <List />
    </ContainerBody>
  );
};

export default compose(withPaginate)(ConsumptionMonitoring);
